<template>
  <base-section
  id="welcome-maceio"
  space="0"
  >
    <v-container>
    <base-section-heading
    title="Welcome to Maceió!"
    color="secondary"
    align="left"
    :toColor="true"
    >

LATS'24 will be held in the <strong>Jatiuca Hotel & Resort</strong>
(<a href="https://www.hoteljatiuca.com.br">https://www.hoteljatiuca.com.br</a>), in Maceió. <br /> <br />

Maceió is the capital city of the state of Alagoas, on the east coast of Brazil. Its historic
center is home of a unique and welcoming culture. It is known for its pastel-colored colonial
houses, a 19th-century cathedral and the Théo Brandão Museum of Anthropology and
Folklore, located in a renovated seafront mansion. Protected by an offshore reef, the coast
is lined with white-sand beaches, nearby Gunga's beach is considered to be one of the
most beautiful beaches in Brazil. It is surrounded by coconut trees, and it positioned right
between the Atlantic Ocean and Roteiro Lake. This position guarantees a unique color of
the ocean surrounding the beach. It is bluer during the low tides and it turns greener during
the high tides when the ocean waters meet the lake waters.
    </base-section-heading>
    <v-carousel
      cycle
      hide-delimiter-background
      show-arrows-on-hover
    >
      <v-carousel-item
        v-for="(slide, i) in slides"
        :key="i"
        :src="slide.src"
        contain
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        />
      </v-carousel-item>
    </v-carousel>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'WelcomeMaceio',

    data: () => ({
      slides: [

      ],
    }),
  }
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
</style>
